<script lang="ts">
  import { goto } from '$app/navigation';
  goto('/review', { replaceState: true });
</script>
